module.exports = __webpack_public_path__ + "img/teamPersonnel.5ed562a2.png";